import { observer } from 'mobx-react-lite';
import { FC, PropsWithChildren } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { CallMemberStatus } from '@gem/call/Model/callModel.types';
import { AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';
import { PopupInfoCard } from '@gem/call/Removable/components/PopupInfoCard/PopupInfoCard';
import { useTranslation } from '@gem/modules/i18n';
import { popupItemStyles } from '@gem/ui-kit';

import { useCallMemberPresenter } from './CallMember.presenter';

const stateTranslations = {
  [CallMemberStatus.NotOnCall]: 'calls_not_on_call',
  [CallMemberStatus.OnCall]: 'calls_on_call',
  [CallMemberStatus.Declined]: 'calls_declined',
  [CallMemberStatus.Left]: 'calls_left',
};

interface ICallMemberProps {
  userId: string;
  onClick?(): void;
  className?: string;
  call: Call;
}

export const CallMember: FC<PropsWithChildren<ICallMemberProps>> = observer(
  ({ userId, onClick, className, children, call }) => {
    const { t } = useTranslation();
    const presenter = useCallMemberPresenter(userId, call);

    const additionalProps = onClick ? { role: 'button', tabIndex: 0, onClick } : {};

    if (!presenter.member) {
      return null;
    }

    return (
      <div
        {...additionalProps}
        className={className}
      >
        <PopupInfoCard
          type={AvatarTypes.Round_10}
          className={popupItemStyles.card}
          avatarTitle={presenter.member.displayName}
          avatarUrl={presenter.member.avatarUrl}
          avatarBackgroundColorIndex={presenter.member.avatarColorIndex}
          title={presenter.member.displayName}
          subtitle={t(stateTranslations[presenter.memberState])}
        />
        {children}
      </div>
    );
  }
);
